import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

const DialogBox = ({ open, handleClose }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "20px", p: 2 },
      }}
    >
      {/* Close Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Heading */}
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1.2rem",
        }}
      >
        Send us your CAD file or design via WhatsApp, Instagram, or Email to get
        an instant quote today!
      </DialogTitle>

      {/* Content with icons */}
      <DialogContent sx={{ textAlign: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 2 }}>
          {/* WhatsApp */}
          <IconButton
            component="a"
            href="https://wa.me/9902204503"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon sx={{ fontSize: 40, color: "green" }} />
          </IconButton>

          {/* Instagram */}
          <IconButton
            component="a"
            href="https://www.instagram.com/third_axis?igsh=MWVoOGNvMDNtYWRleQ=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon sx={{ fontSize: 40, color: "#E1306C" }} />
          </IconButton>

          {/* Email */}
          <IconButton
            component="a"
            href="mailto:sujanchowdaryk@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <EmailIcon sx={{ fontSize: 40, color: "#1E90FF" }} />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogBox;
